import { gql } from "@apollo/client";

const getAssessmentSuggestedAnswerState = gql`
  query getAssessmentSuggestedAnswerState($assessmentId: Int!) {
    assessment(assessmentId: $assessmentId) {
      id
      suggestedAnswersState
    }
  }
`;

export default getAssessmentSuggestedAnswerState;
